import algoliaSearch from 'algoliasearch'
import { algolia, mocking } from 'config'
import mockedFirmIndex from './mocks/firm'

const client = algoliaSearch(algolia.search.appId, algolia.search.apiKey)

export const firmIndex = () =>
  mocking ? mockedFirmIndex : client.initIndex(algolia.firmIndex)

export default client
